import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {reverse} from 'core/urls';
import Button from 'components/button';
import styles from './styles.css';

export default class ClKitsOrderSuccess extends Component {
    static propTypes = {
        border: PropTypes.bool,
        title: PropTypes.string,
        orderId: PropTypes.number,
    };

    render() {
        const className = classNames(styles.root, this.props.className, {
            [styles.border]: this.props.border,
        });

        return (
            <div className={className}>
                <div className={styles.title}>
                    {this.props.title}
                </div>
                <div className={styles.subtitle}>
                    El número de pedido es #{this.props.orderId}
                </div>
                <div className={styles.mainActions}>
                    <Button link={reverse('clDealerTrialSignsCreate', { id: this.props.orderId })} theme='yellow'>
                        Si lo deseas, pueder realizar el pedido de carteles para tu Campo Lider haciendo click acá.
                    </Button>
                </div>
                <div className={styles.actions}>
                    <Button link={reverse('orderDetail', { id: this.props.orderId })} theme='yellow'>
                        Ver detalle del pedido
                    </Button>
                    <Button link={reverse('home')} theme='yellow'>
                        Volver al inicio
                    </Button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/cl-kits-order-success/index.js